import { authLocalStorage } from 'storage/auth';

export const getCurrentPath = () => {
  const { pathname } = window.location;
  return pathname;
};

export const status = authLocalStorage;
